import { render } from "./DecorativoComponent.vue?vue&type=template&id=7e987557&scoped=true"
import script from "./DecorativoComponent.vue?vue&type=script&lang=js"
export * from "./DecorativoComponent.vue?vue&type=script&lang=js"

import "./DecorativoComponent.vue?vue&type=style&index=0&id=7e987557&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e987557"]])

export default __exports__